import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/Avatar.png";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub
} from "react-icons/ai";
import { 
  FaVk,
  FaTelegram
 } from "react-icons/fa";
import { MdOutlineAlternateEmail } from "react-icons/md";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              НЕМНОГО <span className="purple"> О </span> СЕБЕ
            </h1>
            <p className="home-about-body">
              Увлекаюсь информационными технологиями и всем, что с ними связано👨🏻‍💻
              Инструменты с которыми работаю можно посмотреть в разделе <a href="/about" className="purple href-home">стек</a>
              <br />
              <br />Преподаю
              <i>
                <b className="purple"> Python, C++, IT Essintials и робототехнику (arduino) </b>
              </i>
              <br />
              <br />
              Работал в лаборатории первичного биоскрининга с клеточными культурами
              и буду рад посотрудничать в области <span className="purple">генных и клеточных технологий🧬 </span>
              и <span className="purple">Open Sourse </span> проектах
              <br />
              <br />
              Люблю <b className="purple"> путешествовать по России (Калининград ✈️ Камчатка) музыку🎸🥁 и настольные игры🎲 </b>

            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            {/* <h1>СВЯЗАТЬСЯ</h1> */}
            {/* <p>
              Feel free to <span className="purple">connect </span>with me
            </p> */}
            <ul className="home-about-social-links">
            <li className="social-icons">
                <a
                  href="https://github.com/vofanchik"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="mailto:vofanchic@mail.ru"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <MdOutlineAlternateEmail />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://t.me/Kalinin_Vladimir_Michailovich"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <FaTelegram />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://vk.com/vofanchik96"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaVk />
                </a>
              </li>

            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
